<template>
  <div class="base_box alipay-store-page">
    <baseCrumbs v-if="!embedded" />

    <baseSearch :list="filters" @search="search">
      <template #btns>
        <el-button class="btnsty base_but_style" icon="el-icon-refresh" :loading="loading" @click="load">刷新</el-button>
      <admin-rule-help label="说明">资料来源与实际收款门店分开；核验后须显式启用；同一档案可以供多个门店使用；旧交易保持原收款身份</admin-rule-help></template>
    </baseSearch>
    <div class="base_content mt10">
      <baseTable :loading="loading" :list="rows" :tableList="columns" :total="total" :page="page" :pagesize="10" @changePage="changePage">
        <template #pid="scope"><div>{{ scope.row.current ? scope.row.current.pid : '-' }}</div></template>
        <template #merchant="scope"><div class="cell-tips">{{ scope.row.current ? scope.row.current.name : '-' }}</div></template>
        <template #readiness="scope">
          <el-tag size="mini" :type="scope.row.readiness.payment_ready ? 'success' : 'warning'">{{ scope.row.readiness.payment_ready ? '已就绪' : '未就绪' }}</el-tag>
        </template>
        <template #platform_ratio="scope">{{ ratioText(scope.row.platform_ratio) }}</template>
        <template #enabled="scope">
          <el-tag size="mini" :type="scope.row.enabled === 1 ? 'success' : 'info'">{{ scope.row.enabled === 1 ? '已启用' : '已禁用' }}</el-tag>
        </template>
        <template #updated_at="scope">{{ timeText(scope.row.updated_at) }}</template>
        <template #action="scope">
          <div class="row-actions">
            <div class="but_primary" @click="open(scope.row)">更换并启用</div>
            <div v-if="scope.row.enabled === 1" class="but_primary danger-action" @click="disable(scope.row)">禁用</div>
            <div v-else-if="scope.row.current" class="but_primary" @click="open(scope.row)">启用</div>
          </div>
        </template>
      </baseTable>
      <div v-if="failed" class="base_tips">列表加载失败，请重新查询</div>
    </div>
    <el-dialog class="alipay-dialog admin-standard-dialog" :close-on-press-escape="!busy" title="选择门店收款账户" :visible.sync="dialogVisible" width="760px" :close-on-click-modal="false" :show-close="!busy" @closed="closed">
      <div class="collection-sections">
        <section v-if="activeStore">
          <div class="base_form_title">当前收款账户</div>
          <div>{{ activeStore.title }}：{{ activeStore.current ? activeStore.current.name + ' / ' + activeStore.current.pid : '未设置' }}</div>
          <div class="base_tips base_tips_field">当前账户{{ activeStore.readiness.payment_ready ? '已就绪' : '未就绪' }}；下方候选核验不会改变当前关系</div>
          <div v-for="route in activeStore.readiness.routes" :key="route.product + route.client" class="base_tips base_tips_field">{{ ({ h5: '网页支付', jsapi: '小程序支付', f2f: '付款码', qr: '订单码' })[route.product] }} / {{ route.client }}：{{ route.payment_ready ? '已就绪，付款时复核金额' : route.reason || '待核验' }}</div>
          <div v-for="(reasons, key) in activeStore.readiness.missing" :key="key" class="base_tips base_tips_field">{{ reasons.join('；') }}</div>
        </section>
        <section>
          <div class="base_form_title">选择候选收款档案</div>
          <el-form v-admin-search inline @submit.native.prevent="searchCandidates">
            <el-form-item label="商家名称"><el-input v-model="candidateKeyword" placeholder="输入商家名称" size="small" :disabled="busy || candidateLoading" /></el-form-item>
            <el-form-item><el-button class="admin-search-query" size="small" :disabled="busy || candidateLoading" @click="searchCandidates">查询</el-button></el-form-item>
          </el-form>
          <baseTable :fit-content="true" :loading="candidateLoading" :list="candidates" :tableList="candidateColumns" :total="candidateTotal" :page="candidatePage" :pagesize="10" @changePage="candidatePageChanged">
            <template #choice="scope"><el-radio :value="profileId" :label="scope.row.id" :disabled="busy || candidateLoading" @change="selectCandidate(scope.row)"><span class="sr-only">选择 {{ scope.row.name }}</span></el-radio></template>
            <template #configured="scope">{{ scope.row.configured ? '已配置，待核验' : '待补齐配置' }}</template>
          </baseTable>
          <div class="base_tips base_tips_field">仅展示当前账号范围内的档案；资料配置状态不代表支付就绪，核验通过后仍须设为当前账户</div>
        </section>
        <section v-if="check" class="base_tips base_tips_field">候选已核验，尚未启用；证据有效至 {{ check.expires_at }}</section>
      </div>
      <template #footer>
        <el-button :disabled="busy" @click="dialogVisible = false">关闭</el-button>
        <el-button :disabled="!profileId || busy" :loading="busy" @click="verify">核验候选</el-button>
        <el-button type="primary" :disabled="!check || busy" @click="enable">设为当前账户</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import "@/components/common/alipayConfirm.less";
import baseCrumbs from '@/components/common/baseCrumbs.vue';
import baseSearch from '@/components/common/baseSearch.vue';
import baseTable from '@/components/common/baseTable.vue';
import { listStoreCollections, listCollectionCandidates, verifyStoreCollection, enableStoreCollection, disableStoreCollection } from '@/api/weishop/alipayApplyment';
import { eltips } from '@/util/util';
import { resolveWeiShopApi } from '@/views/apps/weishop/region/utils/regionApiMap';
export default {
  name: 'AlipayStoreMerchantBinding', components: { baseCrumbs, baseSearch, baseTable },
  // 嵌在「门店配置」页签里时由外层页面提供面包屑。
  props: { embedded: { type: Boolean, default: false } },
  data() { return { rows: [], total: 0, page: 1, query: {}, loading: false, failed: false, busy: false, listSequence: 0,
    dialogVisible: false, activeStore: null, candidates: [], candidateTotal: 0, candidatePage: 1, candidateKeyword: '', candidateLoading: false,
    candidateSequence: 0, verifySequence: 0, profileId: null, check: null,
    // 搜索条件与微信门店配置一致；分账比例按百分数理解（1 或 1% 都是 1%）。
    filters: [
      { type: 'select', Field: 'store_id', label: '所属门店', style: { width: '200px' }, options: [] },
      { type: 'input', Field: 'keyword', label: '搜索关键词', style: { width: '220px' }, placeholder: '门店/商家名称/PID' },
      { type: 'select', Field: 'payment_ready', label: '支付就绪', style: { width: '140px' }, clearable: true, options: [{ label: '已就绪', value: 1 }, { label: '未就绪', value: 0 }] },
      { type: 'input', Field: 'platform_ratio', label: '分账比例', style: { width: '150px' }, placeholder: '如 1 或 1%' },
    ],
    candidateColumns: [{ prop: 'choice', label: '选择' }, { prop: 'name', label: '商家名称' }, { prop: 'pid', label: '支付宝账户' }, { prop: 'version', label: '资料版本' }, { prop: 'configured', label: '配置状态' }],
    // 列与微信门店配置一致；主商城分账比例与微信同一规则，支付宝分账按它计算，此处只读。
    columns: [{ label: '门店', prop: 'title', minWidth: 220, align: 'left', showOverflowTooltip: true }, { label: '当前收款支付宝账户', prop: 'pid' },
      { label: '名称', prop: 'merchant', minWidth: 280 }, { label: '支付就绪', prop: 'readiness' }, { label: '主商城分账比例', prop: 'platform_ratio' },
      { label: '启用状态', prop: 'enabled' }, { label: '绑定更新时间', prop: 'updated_at' }, { label: '操作', prop: 'action', width: 190, fixed: 'right' }],
  }; },
  created() { this.load(); this.loadStores(); },
  methods: {
    async load() {
      const sequence = ++this.listSequence; this.loading = true; this.failed = false;
      try { const response = await listStoreCollections({ ...this.query, page: this.page, limit: 10 });
        if (sequence !== this.listSequence) return;
        if (response.code !== 200) { this.failed = true; return; }
        this.rows = response.data.list; this.total = response.data.total;
      } catch (_) { if (sequence === this.listSequence) this.failed = true; }
      finally { if (sequence === this.listSequence) this.loading = false; }
    },
    search(query) { this.query = query || {}; this.page = 1; this.load(); },
    // 门店下拉与微信页同一来源，区域账号经 resolveWeiShopApi 只取管辖门店。
    loadStores() {
      this.axios.get(resolveWeiShopApi('/api/weishop/admin/plugin/store/information/index'), { params: { page: 1, limit: 500 } }).then((res) => {
        if (!res || (res.code !== 200 && res.status !== 200)) return;
        const list = (((res.data || {}).data || {}).data || (res.data || {}).data || []);
        const options = (Array.isArray(list) ? list : []).map(item => ({ label: item.title, value: item.id }));
        this.filters.forEach((item) => { if (item.Field === 'store_id') item.options = options; });
      }).catch(() => {});
    },
    timeText(value) { return value ? String(value).replace('T', ' ').slice(0, 19) : '-'; },
    ratioText(value) { const number = Number(value); return value === undefined || value === null || value === '' || !Number.isFinite(number) ? '-' : `${(number * 100).toFixed(2)}%`; },
    changePage(page) { this.page = Number(page); this.load(); },
    open(row) { if (this.busy) return; this.activeStore = row; this.profileId = null; this.check = null; this.candidates = []; this.candidatePage = 1; this.candidateKeyword = ''; this.dialogVisible = true; this.loadCandidates(); },
    closed() { if (this.dialogVisible) return; this.candidateSequence++; this.verifySequence++; this.check = null; this.profileId = null; this.activeStore = null; },
    selectCandidate(row) { if (this.busy || this.candidateLoading) return; this.profileId = row.id; this.check = null; },
    searchCandidates() { if (this.busy || this.candidateLoading) return; this.candidatePage = 1; this.loadCandidates(); },
    candidatePageChanged(page) { if (this.busy || this.candidateLoading) return; this.candidatePage = Number(page); this.loadCandidates(); },
    async loadCandidates() {
      if (!this.activeStore) return;
      this.profileId = null; this.check = null; this.candidates = [];
      const storeId = this.activeStore.store_id; const sequence = ++this.candidateSequence; this.candidateLoading = true;
      try { const response = await listCollectionCandidates(storeId, { page: this.candidatePage, limit: 10, keyword: this.candidateKeyword });
        if (sequence !== this.candidateSequence || !this.activeStore || this.activeStore.store_id !== storeId) return;
        if (response.code !== 200) { this.candidates = []; this.profileId = null; this.check = null; eltips(response.msg || '候选加载失败', 'error'); return; }
        this.candidates = response.data.list; this.candidateTotal = response.data.total;
      } catch (_) { if (sequence === this.candidateSequence) { this.candidates = []; this.profileId = null; this.check = null; } }
      finally { if (sequence === this.candidateSequence) this.candidateLoading = false; }
    },
    async verify() {
      const selected = this.candidates.find(row => row.id === this.profileId);
      if (this.busy || this.candidateLoading || !this.activeStore || !selected) return;
      this.busy = true; this.check = null;
      const sequence = ++this.verifySequence; const storeId = this.activeStore.store_id;
      try { const response = await verifyStoreCollection(storeId, { profile_id: selected.id, version: selected.version });
        if (sequence !== this.verifySequence || !this.dialogVisible || !this.activeStore || this.activeStore.store_id !== storeId || this.profileId !== selected.id) return;
        if (response.code === 200) this.check = response.data.check;
        else eltips(response.msg || '候选核验失败，原收款关系已保留', 'error');
      } catch (_) { if (sequence === this.verifySequence && this.dialogVisible) eltips('候选核验未完成，原收款关系已保留', 'error'); }
      finally { this.busy = false; }
    },
    async enable() {
      if (this.busy || !this.activeStore || !this.check) return;
      this.busy = true;
      try { await this.$confirm('将此候选设为该门店当前收款账户，其他门店保持原关系', '确认收款关系', { customClass: 'alipay-confirm', type: 'warning' });
        const response = await enableStoreCollection(this.activeStore.store_id, { check_id: this.check.id, version: this.check.binding_version });
        this.check = null;
        if (response.code === 200) { this.dialogVisible = false; eltips('门店收款关系已更新', 'success'); }
        else eltips(response.msg || '启用失败，原关系已保留', 'error');
        await this.load();
      } catch (error) { if (error !== 'cancel' && error !== 'close') { this.check = null; eltips('结果待核验，请刷新门店关系', 'error'); await this.load(); } }
      finally { this.busy = false; }
    },
    async disable(row) {
      if (this.busy) return;
      this.busy = true;
      try { await this.$confirm('禁用该门店的支付宝收款，原交易仍保留', '禁用收款关系', { customClass: 'alipay-confirm', type: 'warning' });
        const response = await disableStoreCollection(row.store_id, row.version);
        if (response.code !== 200) eltips(response.msg || '禁用失败，请刷新后核验', 'error');
        await this.load();
      } catch (error) { if (error !== 'cancel' && error !== 'close') { eltips('禁用结果待核验，请刷新后核验', 'error'); await this.load(); } }
      finally { this.busy = false; }
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/components/common/alipayWorkspace.less";
.alipay-store-page { .alipay-page-sections();
  .cell-tips { color: #000; font-size: 14px; line-height: 18px; }
  .row-actions { display: inline-flex; align-items: center; justify-content: center; gap: 8px; white-space: nowrap; }
  .danger-action { color: #f56c6c; }
}
.el-input, .el-select { max-width: 420px; }
.alipay-dialog { .alipay-dialog-frame(); }
.collection-sections { display: flex; flex-direction: column; gap: var(--admin-section-gap, 10px); }
.sr-only { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); }
</style>
